import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Observable} from 'rxjs';
import Grid from '@material-ui/core/Grid';
import {Checkbox as MuiCheckbox} from '@material-ui/core';
import {Translate} from "app/services/translate";

export class Checkbox extends Component {
    static get propTypes() {
        return {
            handleChange$: PropTypes.instanceOf(Observable).isRequired,
        };
    }

    constructor(props) {
        super(props);
        this.state = {checked: false};
        this.label = React.createRef();
        this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount() {
        this.label.current.querySelector('a').addEventListener('click', (evt) => evt.stopPropagation());
    }

    handleChange(evt) {
        this.setState({checked: evt.target.checked});
        this.props.handleChange$.next(evt.target.checked);
    }

    render() {
        const label = Translate('signing_register_newsletter')
            .replace('%privacy_policy_url%', `"${Translate('signing_privacy_policy_url')}"`);

        return (
            <Grid container classes={{container: 'checkbox-container'}}>
                <Grid item xs={"auto"}>
                    <MuiCheckbox
                        color="primary"
                        classes={{
                            root: 'form-checkbox',
                            checked: 'checked',
                        }}
                        id="terms"
                        checked={this.state.checked}
                        onChange={this.handleChange}/>
                </Grid>
                <Grid item xs={10}>
                    <label
                        htmlFor="terms"
                        className="checkbox-label"
                        ref={this.label}
                        dangerouslySetInnerHTML={{__html: label}}/>
                </Grid>
            </Grid>
        );
    }
}

